import { LegalLayout } from './LegalLayout';

export function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" updatedDate="April 29, 2026">
      <section aria-label="Introduction">
        <p>
          This Privacy Policy explains how Grow With Call (“we”, “us”, or “our”)
          collects, uses, and protects information when you contact us or use our
          website. We are committed to handling information responsibly and in
          line with applicable privacy principles.
        </p>
      </section>

      <section aria-label="Information we collect">
        <h2 className="text-base font-semibold text-slate-900">
          Information we collect
        </h2>
        <p className="mt-3">
          We may collect information that you voluntarily provide, such as your
          name, email address, and message details when you contact us.
        </p>
        <p className="mt-3">
          We may also collect basic usage information (for example, approximate
          location, device type, and pages visited) through standard web logs and
          analytics used to maintain and improve the website.
        </p>
      </section>

      <section aria-label="How we use information">
        <h2 className="text-base font-semibold text-slate-900">
          How we use information
        </h2>
        <ul className="mt-3 list-disc space-y-2 pl-5">
          <li>Respond to inquiries and provide requested information.</li>
          <li>Improve website performance, security, and user experience.</li>
          <li>
            Maintain internal records related to communications and service
            discussions.
          </li>
        </ul>
      </section>

      <section aria-label="Sharing">
        <h2 className="text-base font-semibold text-slate-900">
          Sharing of information
        </h2>
        <p className="mt-3">
          We do not sell personal information. We may share information with
          service providers who help operate our website or communications (for
          example, hosting or email providers), only as needed and subject to
          appropriate safeguards.
        </p>
        <p className="mt-3">
          We may also disclose information if required by law or to protect our
          rights, safety, or property.
        </p>
      </section>

      <section aria-label="Data retention">
        <h2 className="text-base font-semibold text-slate-900">Data retention</h2>
        <p className="mt-3">
          We retain information only for as long as needed to fulfill the purposes
          described in this policy, unless a longer retention period is required
          or permitted by law.
        </p>
      </section>

      <section aria-label="Security">
        <h2 className="text-base font-semibold text-slate-900">Security</h2>
        <p className="mt-3">
          We use reasonable administrative and technical safeguards to protect
          information. No method of transmission or storage is completely secure,
          and we cannot guarantee absolute security.
        </p>
      </section>

      <section aria-label="Contact">
        <h2 className="text-base font-semibold text-slate-900">Contact</h2>
        <p className="mt-3">
          If you have questions about this Privacy Policy, contact us at{' '}
          <a
            className="font-semibold text-sky-800 hover:text-sky-900"
            href="mailto:founder@growwithcall.com"
          >
            founder@growwithcall.com
          </a>
          .
        </p>
      </section>
    </LegalLayout>
  );
}

